import React from "react";
import DaoComponenet from "../../component/dao";
export function Dao() {
  return <DaoComponenet />;
}
